var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1302,
    height: 100,
    viewBox: "0 0 1302 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_137_399)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_137_399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25C253.167 85 506.333 5 759.5 50C958.417 82 1139.25 18 1302 40V100H0V25Z",
    fill: "#E0EFF2",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 49.9999C180.833 19.9999 397.833 81.9999 632.917 53.9999C868 25.9999 1085 77.9999 1302 57.9999V99.9999H0V49.9999Z",
    fill: "url(#paint0_linear_137_399)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 68.0001C271.25 48.0001 542.5 86.0001 813.75 66.0001C994.583 50.0001 1175.42 80.0001 1302 70.0001V100H0V68.0001Z",
    fill: "#E0EFF2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_137_399",
    x1: 0,
    y1: 41.5808,
    x2: 0,
    y2: 99.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0EFF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0EFF2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_137_399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1302,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_137_399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1302,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape3);
export default __webpack_public_path__ + "static/media/Shape 3.13335e995e802b03ae5cbe106c205428.svg";
export { ForwardRef as ReactComponent };